/**
 * Abstract base class for creating draw modes.
 */
class DrawModeBase {
  /**
   * Abstract draw mode base constructor.  Not intended to be constructed
   * directly.
   */
  constructor() {
    if (this.constructor === DrawModeBase) {
      throw new Error('Do not create an instance of DrawModeBase')
    }
  }

  /**
   * Called once at the start of the edit mode.
   * @param {Object} featureGeoJson - The feature GeoJSON being edited.
   * @param {Object} opts - Arbitrary options object to pass to draw mode.
   */
  onSetup() {}

  /**
   * Called once at the end of the edit mode.
   */
  onTearDown() {}

  /**
   * Called when the user clicks down and back up on the same point.
   * @param {MapMouseEvent} event - docs.mapbox.com/mapbox-gl-js/api/events/#mapmouseevent
   */
  onClick() {}

  /**
   * Called when the user double clicks on the same point.
   * @param {MapMouseEvent} event - docs.mapbox.com/mapbox-gl-js/api/events/#mapmouseevent
   */
  onDoubleClick() {}

  /**
   * Called when the user clicks down on the map.
   * @param {MapMouseEvent} event - docs.mapbox.com/mapbox-gl-js/api/events/#mapmouseevent
   */
  onMouseDown() {}

  /**
   * Called when the user releases the mouse button on the map.
   * @param {MapMouseEvent} event - docs.mapbox.com/mapbox-gl-js/api/events/#mapmouseevent
   */
  onMouseUp() {}

  /**
   * Called every frame that the user moves the mouse.
   * @param {MapMouseEvent} event - docs.mapbox.com/mapbox-gl-js/api/events/#mapmouseevent
   */
  onMouseMove() {}

  /**
   * Called if the user moves the mouse off of the map container.
   * @param {MapMouseEvent} event - docs.mapbox.com/mapbox-gl-js/api/events/#mapmouseevent
   */
  onMouseOut() {}

  /**
   * Called every render frame.
   * @param {Object} featureGeoJson - The feature GeoJSON being edited.
   * @returns {Array<Object>} A list of GeoJSON features to display on the map.
   */
  toDisplayFeatures() {
    throw new Error('toDisplayFeatures is required to be defined')
  }
}

export default DrawModeBase
